import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const LocationArrow2Icon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <path d="M12.9361 21.1279L10.0861 14.0779L3.03613 11.2279V9.82793L21.0361 3.12793L14.3361 21.1279H12.9361ZM13.5861 17.4279L17.6361 6.52793L6.73613 10.5779L11.6361 12.5279L13.5861 17.4279Z" />
    </SvgIcon>
  );
};
